import axios from "axios";
import { 
    ADD_APP_SETTINGS_EDIT_APP_SETTINGS,
    GET_APP_SETTINGS_DETAILS,
    GET_APP_SETTINGS_COUNTRY_SPECIFIC_TAX_DETAILS
   } from "../config/urlConfig";
import { convertToFormData } from "../utils/commenController";

// <-------------------------APP SETTINGS------------------------------------>

// Function for handling ADD & EDIT  settings  api
export async function handleAddEditAppSettingsApi(appSettingsData, token) {
  try {

    let formData = await convertToFormData(appSettingsData);
    let response = await axios.post(ADD_APP_SETTINGS_EDIT_APP_SETTINGS, formData, {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    });

    return response.data;
  } catch (error) {
    if (error?.response) {
      console.log(error.response.data);

      return error.response.data;
    }
    console.log(error.message);
  }
}

// Function for fetch app settings details
export async function fetchAppSettingsDetailsApi(){
  try{
    try {
  
      let response = await axios.get(`${GET_APP_SETTINGS_DETAILS}`);

  
      return response.data;
    } catch (error) {
      if (error?.response) {
        console.log(error.response.data);
  
        return error.response.data;
      }
      console.log(error.message);
    }
  }catch(error){
    console.log("err", error.message);
    
  }
}

export async function fetchCountrySpecificTaxDetailsApi(currency){
  try{
    try {
  
      const response = await axios.get(`${GET_APP_SETTINGS_COUNTRY_SPECIFIC_TAX_DETAILS}?currency=${currency}`);

  
      return response.data;
    } catch (error) {
      if (error?.response) {
        console.log(error.response.data);
  
        return error.response.data;
      }
      console.log(error.message);
    }
  }catch(error){
    console.log("err", error.message);
    
  }
}